export interface ThemeData {
  variables: string;
  assetsPath: string;
  brandName: string;
  productName: string;
  abaName: string;
  abcName: string;
  atiName: string;
  backupVendor: string;
  limitedUse?: boolean;
}

const config: { acronis: ThemeData, virtuozzo: ThemeData } = {
  acronis: {
    variables: 'src/assets/styles/themes/default',
    assetsPath: '/src/assets/images/acronis',
    brandName: 'Acronis',
    productName: 'Acronis Cyber Infrastructure',
    abaName: 'Acronis Cyber Protect',
    abcName: 'Acronis Cyber Protect Cloud',
    atiName: 'Acronis True Image',
    backupVendor: 'Acronis',
    limitedUse: true,
  },
  virtuozzo: {
    variables: 'src/assets/styles/themes/default',
    assetsPath: '/src/assets/images/virtuozzo',
    brandName: 'Virtuozzo',
    productName: 'Virtuozzo Infrastructure',
    abaName: 'Acronis Cyber Protect',
    abcName: 'Acronis Cyber Protect Cloud',
    atiName: 'Acronis True Image',
    backupVendor: 'Acronis',
  }
};

export default config;
